<template>
  <frontoffice-frame :padding-content="false">
    <b-container v-if="isLoading" class="loader-section">
      <frontoffice-loader/>
    </b-container>

    <div v-else id="page" class="front-layout booking-unlogged">
      <headbar class="headbar" />

      <b-container v-if="!isLoading" class="offline-booking-form">
        <div class="page-title">
          <h2>{{ $t('_prelogged_request') }}</h2>
        </div>

        <div>
          <div><b>{{ $t('_yourContact') }}</b></div>
          <div :style="{'margin-left': '2em'}">{{ fullName(bbaContact, false, true) }} : {{ bbaContact.phone }}</div>
        </div>

        <offline-booking-form :is-prelogged="true" :prelogged-infos="preloggedInfos" />
      </b-container>
    </div>
  </frontoffice-frame>
</template>

<script>
import headbar from '@/components/frontoffice/header'
import frontofficeFrame from '@/components/frontoffice/frame'
import frontofficeLoader from '@/components/frontoffice/loader'
import OfflineBookingForm from '@/components/frontoffice/OfflineBooking/OfflineBookingForm'
import CommonApi from '@/api/commonApi'
import formatter from '@/components/global/mixins/formatterMethods'

export default {
  components: {
    headbar,
    frontofficeFrame,
    frontofficeLoader,
    OfflineBookingForm
  },

  mixins: [formatter],

  data () {
    return {
      isLoading: true,
      isDisplayable: false,
      companyInputFields: [],
      companyUniqueChain: this.$route.params.companyUid,
      onlyOne: false,
      logo: null,
      mealContribution: null,
      bbaContact: null
    }
  },

  created () {
    let api = new CommonApi()
    api.getUnloggedCompanyData(this.companyUniqueChain, this.$route.params.values)
      .then(response => {
        if (response.data.success) {
          let data                = response.data.data
          this.isDisplayable      = data.isDisplayable
          this.companyInputFields = data.inputFields
          this.onlyOne            = data.onlyOne
          this.logo               = data.logo
          this.mealContribution   = data.mealContribution
          this.companyUniqueChain = data.uniqueChain
          this.bbaContact         = data.bbaContact
          this.isLoading          = false
        }
      })
  },

  computed: {
    preloggedInfos () {
      return {
        companyInputFields: this.companyInputFields,
        companyUniqueChain: this.companyUniqueChain,
        onlyOne:            this.onlyOne,
        mealContribution:   this.mealContribution,
        bbaContact:         this.bbaContact
      }
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/sass/booking_unlogged.scss';
  @import '@/assets/sass/frontoffice/modal.scss';
</style>
